import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <React.Fragment><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" /><path fill="none" d="M0 0h24v24H0z" /></React.Fragment>
, 'KeyboardArrowUp');
